/**
 * 新商品推荐API接口
 */
import Vue from "vue"
import axios from '@/utils/http';
const api = {
  inittemplate() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/commodity/inittemplate`, {
      mask:false
    });
  },
  //检索
  search(_param) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/commodity/list`, {
      params: _param
    });
  },
  //得到指定明细数据
  detail(commodityId) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/commodity/detail/`+commodityId, {
      mask:false
    });
  },
  /**
   * 答复指定新商品
   * @param :_commodityId 指定商品id
   * @param :_confirmMemo 答复内容
   * @returns {*}
   */
  confirm(params) {
    return axios.put(`${Vue.prototype.$base.API_PATH}/commodity/confirm`,params);
  },
  //登录新商品时得初始化
  addInit() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/commodity/add-init/`, {
      mask:false
    });
  },
  //得到接收人信息
  getConfirmUser(confirmUser) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/commodity/confirm-user/`+confirmUser, {
      mask:false
    });
  },
  //商品基础信息登录-商品基础信息登录
  add(params) {
    return axios.put(`${Vue.prototype.$base.API_PATH}/commodity/add`,params);
  },
  //新商品推荐-新商品推荐查看更新
  examine(params) {
    return axios.put(`${Vue.prototype.$base.API_PATH}/commodity/examine`, params);
  }
}
export default api;



// WEBPACK FOOTER //
// ./src/api/commodity.js